import React, { useContext, useState } from "react";
import { TimeBookingContext } from "../../context/TimebookingContext";
import "./style.scss";

interface IActiveTimeBookingDisplay {
    taetigkeit: string;
    datum: string;
    textExtern: string;
}

function formatStartTime(datum: string): string {
    const date = new Date(datum);
    if (isNaN(date.getTime())) return "--:--";
    return date.toLocaleTimeString("de-CH", { hour: "2-digit", minute: "2-digit" });
}

// Shows the currently running timebooking in the header and allows to stop it
function ActiveTimeBooking() {
    const { isActive, contextTimeBookingData, startTimeBooking, setContextTimeBookingData } =
        useContext(TimeBookingContext);
    const [stopping, setStopping] = useState<boolean>(false);
    const [text, setText] = useState<string>("");
    const [posting, setPosting] = useState<boolean>(false); // posting to TimeSafe, can take a few seconds

    // The running timebooking comes from thanos26 (loaded by the TimeBookingContext after login)
    const booking: IActiveTimeBookingDisplay | undefined = isActive
        ? {
              taetigkeit: contextTimeBookingData.taetigkeitBezeichnung || `#${contextTimeBookingData.taetigkeitID}`,
              datum: contextTimeBookingData.datum,
              textExtern: contextTimeBookingData.textExtern
          }
        : undefined;

    const handleStopClick = () => {
        setText(booking?.textExtern ?? "");
        setStopping(true);
    };

    const handleBook = async () => {
        if (text.trim() === "" || !isActive || posting) return;

        // same flow as the offer: set text on the open booking, then stop it (startTimeBooking toggles)
        let localTb = contextTimeBookingData;
        localTb.textExtern = text;
        setContextTimeBookingData(localTb);
        setPosting(true);
        try {
            await startTimeBooking();
        } finally {
            setPosting(false);
        }
        setStopping(false);
    };

    if (!booking) {
        return (
            <div className="active-timebooking">
                <span className="active-timebooking__label">Keine Zeitbuchung eingestempelt</span>
            </div>
        );
    }

    return (
        <div className="active-timebooking">
            <div className="active-timebooking__info">
                <span className="active-timebooking__label">Aktuelle Tätigkeit:</span>
                <span className="active-timebooking__value" title={booking.taetigkeit}>
                    {booking.taetigkeit}
                </span>
                <span className="active-timebooking__label">eingestempelt seit:</span>
                <span className="active-timebooking__value">{formatStartTime(booking.datum)}</span>
            </div>

            {!stopping && (
                <button className="active-timebooking__stop" title="Ausstempeln" onClick={handleStopClick}>
                    ◻
                </button>
            )}
            {stopping && (
                <div className="active-timebooking__book">
                    <input
                        autoFocus
                        type="text"
                        placeholder="Buchungstext"
                        value={text}
                        disabled={posting}
                        onChange={(e) => setText(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.repeat) handleBook();
                            if (e.key === "Escape" && !posting) setStopping(false);
                        }}
                    />
                    <button
                        className={`active-timebooking__confirm ${text.trim() === "" || posting ? "disabled" : ""}`}
                        disabled={posting}
                        onClick={handleBook}>
                        {posting ? "..." : text.trim() === "" ? "!TEXT" : "BOOK"}
                    </button>
                    <button className="active-timebooking__cancel" title="Abbrechen" onClick={() => setStopping(false)}>
                        ✕
                    </button>
                </div>
            )}
        </div>
    );
}

export default ActiveTimeBooking;
